
import { defineComponent, ref, toRefs } from "vue";

interface SVGElement extends Element {
  beginElement(): SVGElement;
  endElement(): SVGElement;
}

export default defineComponent({
  name: "CloseSVG",
  props: {
    propId: String,
    fillColor: String,
    strokeColor: String,
    flipFill: String,
    flipStroke: String,
  },
  setup(props) {
    const propsRefs = toRefs(props);

    const svgFillColor = ref<string>("#fff");
    const svgStrokeColor = ref<string>("#000");

    const svgFlipFill = ref<string>("#000");
    const svgFlipStroke = ref<string>("#fff");

    if (propsRefs.fillColor && propsRefs.fillColor.value) svgFillColor.value = propsRefs.fillColor.value;
    if (propsRefs.strokeColor && propsRefs.strokeColor.value) svgStrokeColor.value = propsRefs.strokeColor.value;

    if (propsRefs.flipFill && propsRefs.flipFill.value) svgFlipFill.value = propsRefs.flipFill.value;
    if (propsRefs.flipStroke && propsRefs.flipStroke.value) svgFlipStroke.value = propsRefs.flipStroke.value;

    return {
      svgFillColor,
      svgStrokeColor,
      svgFlipFill,
      svgFlipStroke,
    };
  },
  methods: {
    triggerAnimations(): void {
      document.querySelectorAll(`#${this.propId} .animate`).forEach((value: Element) => {
        let svgElem = value as SVGElement;
        svgElem.beginElement();
      });
    },
    stopAnimations(): void {
      document.querySelectorAll(`#${this.propId} .animate`).forEach((value: Element) => {
        let svgElem = value as SVGElement;
        svgElem.endElement();
      });
    },
  },
});
